<template>
  <div class="business">
    <a-tree
      v-model="tree.checkedKeys"
      :selectable="false"
      checkable
      defaultExpandAll
      :key="tree.key"
      :replaceFields="{ children: 'children', title: 'name', key: 'customId' }"
      :tree-data="tree.data"
      @check="treeCheck"
    />
  </div>
</template>
<script>
export default {
  name: 'Business',
  props: {
    orgId: [Number, String],
    orgType: [Number, String],
  },
  data() {
    return {
      loading: false,
      tree: {
        key: Date.now(),
        checkedKeys: [],
        data: [
          {
            name: '首页',
            flag: true,
          },
        ],
        resultData: [],
      },
    }
  },
  created() {
    this.getTreeData()
  },
  methods: {
    // 数组转为树形结构
    editTree(list, id = 0, property) {
      const results = []
      // 一维数组转为树形结构
      for (let i = 0; i < list.length; i++) {
        list[i].customId = list[i].id + ':' + property
        list[i].children = list.filter((f) => {
          if (f.parentId === list[i].id) {
            f.parentNode = list[i]
            return true
          }
          return false
        })
        if (list[i].parentId === id) {
          results.push(list[i])
        }
      }
      // 初始化树形结构选中状态，保存选中状态数据
      for (let i = 0; i < list.length; i++) {
        // 选中状态数据
        if (list[i].flag) {
          this.tree.resultData.push({
            moduleId: list[i].customId,
            property: list[i].property,
          })
        }
        // 初始化树形结构选中状态
        if (!list[i].children.length && list[i].flag) {
          this.tree.checkedKeys.push(list[i].customId)
        }
        // 树形结构最后一级父级样式
        if (!list[i].children.some((s) => s.children.length)) {
          list[i].className = 'tree-last-parent'
        }
      }
      return results
    },
    filterItem(data) {
      return data.filter((v) => {
        if (v.moduleInfoList) {
          v.children = this.filterItem(v.children)
          return true
        } else {
          if (v.name == '管理中心' && v.children.some((v) => v.name == '班级管理')) {
            return false
          }
          return true
        }
      })
    },
    /** 获取权限树 */
    async getTreeData() {
      const { data } = await this.$http.Mechanism.GetOrganizationModule({ organizationId: this.orgId, appid: '6' })
      this.tree.data = data.data.map((v) => ({
        children: this.editTree(v.moduleInfoList, 0, v.property),
        ...v,
        name: v.propertyName,
      }))
      if (this.tree.data.length == 1) {
        this.tree.data = this.tree.data[0].children
      }
      if (this.orgType == 7) {
        this.tree.data = this.filterItem(this.tree.data)
      }
      this.tree.data = [
        {
          name: '选择全部',
          id: 'all',
          customId: 'all',
          className: 'tree-select-all',
          children: this.tree.data,
        },
      ]
      this.tree.key = Date.now()
    },
    getIds() {
      return this.tree.resultData.map((v) => ({ ...v, moduleId: typeof v.moduleId === 'string' ? v.moduleId.split(':')[0] : v.moduleId }))
    },
    // 树形结构选中事件
    treeCheck(checkedKeys, { checked, node }) {
      let data = node.dataRef || node
      data.flag = checked
      if (data.customId === 'all' && !checked) {
        this.tree.resultData = []
      }
      this.treeCheckNode(checked, data)
      if (Array.isArray(data.children) && data.children.length) {
        for (let i = 0; i < data.children.length; i++) {
          this.treeCheck(checkedKeys, { checked, node: data.children[i] })
        }
      }
    },
    // 树形结构选中数据处理
    treeCheckNode(checked, node) {
      if (node.customId === 'all') {
        return
      }
      if (checked) {
        if (!this.tree.resultData.some((s) => s.moduleId === node.customId)) {
          this.tree.resultData.push({
            moduleId: node.customId,
            property: node.property,
          })
        }
      } else {
        if (!Array.isArray(node.children) || !node.children.length || node.children.every((e) => !e.flag)) {
          this.tree.resultData = this.tree.resultData.filter((f) => f.moduleId !== node.customId)
        }
      }
      if (node.parentNode) {
        this.treeCheckNode(checked, node.parentNode)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.business {
  margin: 20px 0;

  ::v-deep .tree-select-all {
    & > .ant-tree-child-tree {
      padding-left: 0;
      border-top: 1px solid #f0f0f0;
      margin-top: 8px;
    }

    .tree-last-parent .ant-tree-child-tree {
      display: flex;

      .ant-tree-treenode-switcher-open {
        padding: 4px 0;
      }

      .ant-tree-child-tree {
        margin-top: 4px;
      }
    }
  }

  ::v-deep .ant-tree li span.ant-tree-switcher {
    display: none;
  }
}
</style>
